export default {
  primary: "#E40046", // primary color for citymall logo, btns
  fadedPrimary: "rgba(228, 0, 70, 0.5)",
  primaryBg: "#F7F7F7", // used as the primary app bg color
  silver: "#C4C4C4", // used in btns, and fonts
  ceruleanBlue: "#3F49D0", // fb btn
  lima: "#55CD1D", // success, progress bar
  mediumBlacklightBlack: "rgba(0, 0, 0, 0.56)", // used in fonts
  mercury: "#E5E5E5",
  pacificBlue: "#0099CA", // more needed amount txt
  white: "#ffffff",
  modalBg: "rgba(255, 255, 255, 0.9)",
  black: "#000",
  errorRed: "#C41A16",
  orange: "#FFB800",
  mediumBlack: "rgba(0, 0, 0, 0.86)",
  lightMediumBlack: "rgba(0, 0, 0, 0.36)",
  lighterBlack: "rgba(0, 0, 0, 0.1)", // for image border
  darkBackground: "#F6F7F9",
  extraLightBlack: "rgba(0, 0, 0, 0.3)",
  yellow: "#FFC700",
  shadow: "rgba(0, 0, 0, 0.08)",
  shadowLighter: "rgba(0, 0, 0, 0.05)",
  cancelledText: "#ff5722",
  pendingText: "#ff9800",
  deliveredText: "#55CD1D",
  dispatchedText: "#8bc34a",
  searchBg: "#F1F3F6",
  success: "#00DD73",
  lima1: "#4FBA6F",
  primaryv2: "#FF8080",
  mountainMeadow: "#1AB975",
  shakespeare: "#4398D1",
  internationalOrange: "#F25700",
  profileGrad1: "#FF4D4D",
  profileGrad2: "#E51739",
  askLocationBg: "#F7EEE9",
  accountIcon: "rgba(252, 177, 177, 1)",
  plain_green: "#00AB59",
  plain_red: "#FF2E00",
  plain_amber: "#FF7A00",
  blank_grey: "rgba(0, 0, 0, 0.1)",
  lightGrayWhite: "#fbfbfb",
  modalBackground: "rgba(0,0,0,0.5)",
  black2: "#000000",
  lineColor: "#F4F4F4",
  lightGreen: "#9CC450",
  darkGreen: "#00894C",
  mediumGreen: "rgb(121, 174, 91)",
  lightDarkGreen: "rgb(83, 132, 71)",
  veryLightGreen: "#DBEEE5",
  transPlainGreen: "rgba(0, 171, 89, 0.7)",
  skyBlue: "rgba(177, 232, 255, 1)",
  rgbaBlue: "rgba(177, 232, 255, 0.8)",
  lightSkyBlue: "rgba(177, 255, 222, 0)",
  darkSkyBlue: "#6FB7D6",
  trans_209_248: "rgba(209, 248, 248, 0)",
  blueText: "#4D6C91",
  color_3782A3: "#3782A3",
  veryLightSkyBlue: "#D1ECF3",
  lightOrange: "#FFDF77",
  veryLightOrange: "#FFF4D2",
  borderColor: "rgba(0, 0, 0, 0.4)",
  borderColor2: "rgba(217, 217, 217, 1)",
  borderColor3: "rgba(194, 194, 194, 1)",
  veryLightOrange_rgb: "rgba(192, 110, 53, 0.05)",
  color_D9D9D9: "#D9D9D9",
  color_808080: "#808080",
  orange_rgba_107: "rgba(255, 107, 107, 0.7)",
  yellow_back: "#FFDB67",
  light_text_yellow: "rgba(78, 52, 0, 0.86)",
  paleYellow: "rgba(255, 184, 0, 0.2)",
  dark_green: "#11998E",
  lightGreenshade: "#e6f7ef",
  greenHaze: "rgba(0, 171, 89, 1)",
  red: "rgba(255, 0, 0, 1)",
  basketBallOrange: "rgba(255, 125, 96, 1)",
  lightRed: "#FFE1E5",
  lightGreenshade2: "#E8F7E5",
  lightYellow: "#FFF7E5",
  lightGrey: "rgba(235, 235, 235, 1)",
  darkGrey: "rgba(150, 150, 150, 1)",
  polarGreen: "#092B00",
  polarGreenLight: "#D9F7BE",
  polarGreenLighter: "#F6FFED",
  black06: "rgba(0, 0, 0, 0.6)",
  black02: "rgba(0, 0, 0, 0.2)",
  Gray20: "#333",
  Gray40: "#5C5C5C",
  lightgrey2: "rgba(247, 247, 247, 1)",
  textBlue: "#4874FE",
  Gray: "#e6e6e6",
  DarkGray: "#ddd",
  DarkerGray: "#999",
  Whiteish: "#fff",
  blue: "#4874FE",
  grey: "#676767",
  skyBlue2: "rgba(196, 39, 39, 1)",
  red2: "rgba(220, 0, 0, 1)",
  disableGrey: "rgba(236, 236, 236, 1)",
  disableFont: "rgba(189, 189, 189, 1)",
  bgcolor: "#EDF0F3",
  devOverlayBg: "#1a1a2e",
  devToolbarBg: "#16213e",
  slackPurple: "#4A154B",
  slackBlue: "#36C5F0",
  topSkuSectionBg: "#E8F5E9",
  headerBg: "#F4FAF5",
  otherCrateBg: "#FFFEF2",
  royalBlue: "#4274EA",
  grayishBlue: "#636e72",
  dimGray: "#666",
  lightGray: "#F8F8F8",
  darkGrayBlue: "#2D3436",
  lightGray2: "#F2F4FB",
  blue3: "rgba(47, 128, 237, 1)",
  blue4: "rgba(235, 244, 255, 1)",
  btnGreen: "rgba(25, 129, 85, 1)",
  newTagGreen: "#00BA6E",
};
